import {ActivitiesDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'CREATE_ACTIVITY';

export async function createActivity(token: string, payload: Record<string, unknown>) {
    try {
        const result = await ActivitiesDao.createActivity(token, payload);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création de l\'activité',
            error: error
        });
    }
}
